// extracted by mini-css-extract-plugin
export default {"global":"Home_global__0gHxW","comingSoonDiv":"Home_comingSoonDiv__FI6sR","overallContainer":"Home_overallContainer__49oTJ","textContent":"Home_textContent__KPIzn"};